import {useGetAndSet} from "./useGetAndSet";
import {createSetMovementRateDataAction} from "../actions/dataActions";

export const useMovementsRateData =(params, dataFresh) => {
    return useGetAndSet("movementrate", params, createSetMovementRateDataAction, dataFresh);
}